import { useAppointment } from "../../../context/AppointmentContext";

const MobileCTA = () => {
    const { openAppointment } = useAppointment();
    return (
        <div className="mobile-cta d-block d-lg-none">
            <div className="cta-wrapper">
                <button onClick={() => openAppointment("Mobile CTA")}>
                    Book Appointment
                </button>
                <a href="tel:+919994288800" className="mobile-cta-emergency">
                    Emergency 24/7
                </a>
            </div>
        </div>
    );
};

export default MobileCTA;